export const DriversTableConfig: NeoTableConfig = {
  title: "Drivers",
  table: {
    columns: [
      {
        uid: "driverId",
        name: "Driver ID"
      },
      {
        uid: "name",
        name: "Name"
      },
      {
        uid: "phone",
        name: "Phone"
      },
      {
        uid: "operator",
        name: "Operator"
      },
      {
        uid: "rfidNo",
        name: "RFID No"
      },
      {
        uid: "licenceNo",
        name: "Licence No"
      },
      {
        uid: "licenceExpiryDt",
        name: "Licence Expiry Date"
      },
      {
        uid: "image",
        name: "Image"
      },
      {name: "Actions", uid: "actions", type: "actions"}
    ],
    activeColumns: [
      "driverId",
      "name",
      "phone",
      "operator",
      "rfidNo",
      "licenceNo",
      "licenceExpiryDt",
      "image",
      "actions"
    ],
    style: {
      height: "h-full"
    },
    meta: {
      id: 3,
      title: "Manage Drivers",
      description: "Total Drivers",
      hasSearch: true,
      hasUpload: true,
      hasDownload: true,
      hasAdd: true,
      hasActions: true,
      hasCheckbox: false,
      hasFilter: false,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: true
    },
    url: {
      page: {
        view: "drivers/${navId}/view/driver-details",
        add: "drivers/new/create/driver",
        edit: "drivers/${navId}/edit/driver"
      },
      api: {
        upload: "/api/drivers/upload",
        download: "/api/drivers/download",
        delete: "/api/drivers/delete",
        get: "/api/drivers/list",
        deactivate: "/api/driver/status/update"
      }
    },
    actions: [
      {
        key: "view",
        label: "View",
        type: "navigate",
        isVisible: true
      },
      {
        key: "addeditDriver",
        label: "Edit",
        type: "modal",
        isVisible: true
      },
      // enable for phase 2
      {
        key: "delete",
        label: "Delete",
        type: "modal",
        isVisible: false
      },
      {
        key: "deactivate",
        label: "Deactivate",
        type: "modal",
        isVisible: false
      }
    ]
  }
};
